export const SET_IS_WAITING_FOR_ESTIMATIVE = 'SET_IS_WAITING_FOR_ESTIMATIVE';

export const SET_LOADING = 'SET_LOADING';

export const SET_PIECES_SELECTED = 'SET_PIECES_SELECTED';

export const RESET_TREE_EXPORT_CREATIVES = 'RESET_TREE_EXPORT_CREATIVES';
